"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.factsByPropertyByType = void 0;
const key_by_1 = require("../../helpers/key-by");
exports.factsByPropertyByType = (state = {}, action = {}) => {
    switch (action.type) {
        case 'FACTS_GET_BY_ACCOUNT_RECEIVE':
            const factsWithProperties = action.payload.facts.filter((fact) => fact.property);
            const next = factsWithProperties.reduce((all, current) => {
                const propertyId = current.property;
                if (typeof all[propertyId] !== 'object') {
                    all[propertyId] = {};
                }
                all[propertyId][current.type] = current;
                return all;
            }, {});
            return Object.assign(Object.assign({}, state), next);
        case 'FACTS_GET_BY_PROPERTY_RECEIVE':
            return Object.assign(Object.assign({}, state), { [action.payload.propertyId]: key_by_1.keyEntitiesBy(action.payload.facts, 'type') });
        case 'FACT_UPSERT_PROPERTY_RECEIVE':
            const existingFacts = state[action.payload.propertyId] || {};
            return Object.assign(Object.assign({}, state), { [action.payload.propertyId]: Object.assign(Object.assign({}, existingFacts), { [action.payload.fact.type]: action.payload.fact }) });
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map